module.exports = __webpack_public_path__ + "img/icons8-small-business-96.d5de8f07.png";